import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useDashboardContext } from '../../pages/dashboard/context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

const styles = {
  container: {
    position: 'relative',
    width: '100%'
  },
  input: {
    width: '100%',
    padding: '10px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    fontSize: '16px',
    outline: 'none'
  },
  list: {
    position: 'absolute',
    width: '100%',
    maxHeight: '200px',
    overflowY: 'auto',
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    borderRadius: '4px',
    listStyle: 'none',
    margin: '0',
    padding: '0',
    zIndex: '10'
  },
  optionItem: {
    padding: '10px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f0f0f0'
    }
  }
};

const CustomDropdown = ({ options, onSelect, setOptions, onSubmit }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);
  const [selectedOption, setSelectedOption] = React.useState('');
  const { setStudentId } = useDashboardContext();

  const handleSelectOption = (option) => {
    setIsOpen(false);
    setSelectedOption(option.lName + ' ' + option.fName);
    handleStudentId(option.login);
  };

  const handleStudentId = (id) => {
    setStudentId(id);
  };

  const handleInputFocus = () => {
    setIsOpen(true);
  };

  const handleInputBlur = () => {
    setTimeout(() => {
      setIsOpen(false);
    }, 200);
  };

  const handleInputChange = (event) => {
    setSearchTerm(event.target.value);
    if (event.target.value.length >= 3) {
      setSelectedOption(event.target.value);
      onSelect(event.target.value);
    } else {
      setSelectedOption('');
      setOptions([]);
    }
  };

  const reset = () => {
    setSearchTerm('');
    setSelectedOption('');
    setOptions([]);
  };

  useEffect(() => {
    if (isOpen) {
      inputRef.current.focus();
    }
  }, [isOpen]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('click', handleOutsideClick);
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    reset();
  }, [onSubmit]);

  return (
    <div style={styles.container} ref={dropdownRef} className="dropdown-search">
      <input
        type="text"
        placeholder="Select a member"
        onFocus={handleInputFocus}
        onBlur={handleInputBlur}
        onChange={handleInputChange}
        value={selectedOption || searchTerm}
        style={styles.input}
        ref={inputRef}
        className="form-control"
      />
      <span>
        <FontAwesomeIcon icon={faChevronDown} />
      </span>
      {isOpen && (
        <ul style={styles.list}>
          {options.map((option, index) => (
            <li
              key={option.login + '-' + index}
              onClick={() => handleSelectOption(option)}
              style={styles.optionItem}>
              {option.lName + ' ' + option.fName}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

CustomDropdown.propTypes = {
  options: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
  setOptions: PropTypes.func.isRequired,
  onSubmit: PropTypes.string
};

export default CustomDropdown;
